module.exports = __webpack_public_path__ + "img/facepaint-1_jp.9d4fa87.jpg";